import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';
import { getGhaInfo } from '../../../store/actions/ghaAction';

import ghaRemote from '../../../api/ghaRemote';
import { History } from 'history';

import User from '../../../models/User';
import GhaDock from '../../../models/GhaDock';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import PickupOrderGha from '../../../models/PickupOrderGha';
import DriverInfoModel from '../../../models/GhaManualEntryDriverInfo';
import { DelivererType } from '../../../models/DelivererType.enum';
import GhaModel from '../../../models/Gha';

import moment from 'moment';
import queueRemote from '../../../api/queueRemote';
import DriverQueue from '../../../models/DriverQueue';
import AirlineType from '../../../models/AirlineType';
import AwbReturnModal from './AwbReturnModal';
import ManualEntryEdit from '../../../models/ManualEntryEdit';
import cartRemote from '../../../api/cartRemote';
import Cart from '../../../models/Cart';
import { deleteAwbFromCart, updateWholeCart } from '../../../store/actions/cartAction';
import { findCartItemByCodeAndNumber } from '../../../utils/cartService';
import PickupOrder from '../../../models/PickupOrderGha';
import { ReturnReason } from '../../../models/ReturnAwb';
import Awb from '../../../models/Awb';
import AlternativePaymentOptions from '../../../models/PaymentOptions';
import paymentsRemote from '../../../api/paymentsRemote';

const ALL: boolean = true;
const initialErrors = {
  driverName: '',
  driverIdType: '',
  driverId: '',
  truckPlateNumber: '',
  truckingCompany: '',
  arrivalTime: '',
  rfsNumber: ''
};

const initialReturnErrors = {
  reason: '',
  pieces: 0,
  weight: 0,
  forwarderId: -1,
  orderNumber: ''
}

interface ManualEntryModalContainerProps {
  receiveError: (error: any) => void;
  user: User;
  getGhaInfo: Function;
  awbNumber: string;
  modalOpen: boolean;
  history: History;
  awb: Awb;
  cart: Cart;
  handleCloseModal: (type: string) => void;
  driverData: {
    name: string;
    company: string;
    check_in: any;
    driverId?: number;
  };
  updateCart: Function;
  gha: GhaModel;
  manualEntryEdit: ManualEntryEdit;
  handleOpenModal: (type: string) => void;
  order: PickupOrder;
  deleteAwbFromCart: Function;
  selectedAwbNumber: string;
  selectedAwbCode: string
};

interface ManualEntryModalContainerState {
  ghaDocks: Array<GhaDock>;
  driverInfo: DriverInfoModel;
  selectedDock: number | null;
  errors: DriverInfoModel;
  delivererType: string;
  airlines: AirlineType[];
  returnDetails: ReturnReason;
  returnCharges: string;
  returnErrors: ReturnReason;
  paymentInfoSelect: string;
  paymentOptions: AlternativePaymentOptions;
  paymentType: string;
  showText: boolean;
  navigate: boolean
};

class ManualEntryModalContainer extends Component<ManualEntryModalContainerProps, ManualEntryModalContainerState> {

  state: ManualEntryModalContainerState = {
    ghaDocks: [],
    driverInfo: {
      driverName: '',
      driverId: '',
      driverIdType: '',
      truckPlateNumber: '',
      truckingCompany: '',
      arrivalTime: '',
      rfsNumber: '',
      interlineTransfer: ''
    },
    paymentType: '',
    paymentInfoSelect: '',
    errors: initialErrors,
    returnErrors: initialReturnErrors,
    selectedDock: null,
    delivererType: DelivererType.FORWARDER,
    airlines: [],
    returnDetails: {
      reason: '',
      pieces: Number(this.props.awb.pieces),
      weight: Number(this.props.awb.weight),
      forwarderId: -1,
      orderNumber: ''
    },
    returnCharges: '',
    paymentOptions: {} as AlternativePaymentOptions,
    showText: false,
    navigate: false
  }

  componentDidMount() {

    this.props.getGhaInfo(this.props.user.gha_id);
    this.getGhaDocks(this.props.user.gha_id);
    this.setDriverInfo();
    this.addToCart();
    this.getAltPaymentOptions();
    if(this.props.order) {
      const returnDetails = { ...this.state.returnDetails };
      returnDetails.forwarderId = this.props.order.id_forwarder;
      returnDetails.orderNumber = this.props.order.number;
      this.setState({ returnDetails });
    }
  }

  componentDidUpdate(prevProps: ManualEntryModalContainerProps): void {

  }

  setDriverInfo = (): void => {

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    driverInfo.driverName = this.props.driverData.name;
    driverInfo.truckingCompany = this.props.driverData.company;
    driverInfo.waitingListId = this.props.driverData.driverId;
    driverInfo.arrivalTime = this.props.driverData.check_in ? moment(this.props.driverData.check_in).format('HH:mm'): this.setArrivalTime();

    this.setState({ driverInfo });
  }


  getGhaDocks = (ghaID: any): void => {

    ghaRemote.getGhaDocks(ghaID).then((resp: ApiResponse<Array<GhaDock>>) => {

      const docks: Array<GhaDock> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (docks && docks.length > 0) {
        this.setState({ ghaDocks: docks });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  closeModal = (type: string) => {
    this.props.handleCloseModal(type);
    this.props.deleteAwbFromCart(this.props.awb.code, this.props.awb.number);
  }


  setArrivalTime = (): string => {

    let driverInfo: DriverInfoModel = { ...this.state.driverInfo };

    const date = new Date()
    const time = moment(date).format('HH:mm').toString();
    driverInfo.arrivalTime = time;
    this.setState ({ driverInfo });

    return time;
  }


  handleChange = (propertyName: string, event: any): void => {

    let value: any;

    if (propertyName === 'forwarderCompany' || propertyName === 'forwarderStation' || propertyName === 'cityCode') {
      value = event.value;
    }
    else {
      value = event.target.value;
    }

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    const returnDetails = { ...this.state.returnDetails }
    let returnCharges = this.state.returnCharges;
    let paymentInfoSelect = this.state.paymentInfoSelect;
    switch (propertyName) {
      case 'driverName': driverInfo.driverName = value ; break;
      case 'driverId':
        driverInfo.driverId = value;
        driverInfo.maskedDriverId = value;
      break;
      case 'driverIdType': driverInfo.driverIdType = value; break;
      case 'truckPlateNumber': driverInfo.truckPlateNumber = value; break;
      case 'truckingCompany': driverInfo.truckingCompany = value; break;
      case 'arrivalTime': this.changeArrivalTime(value); break;
      case 'dockNumber': this.setState({ selectedDock: value }); break;
      case 'rfsNumber': driverInfo.rfsNumber = value ; break;
      case 'airline': driverInfo.interlineTransfer = value ; break;
      case 'returnCharges': returnCharges = value ; break;
      case 'paymentInfoSelect': paymentInfoSelect = value; break;
      case 'reason': returnDetails.reason = value ; break;
      case 'pieces': returnDetails.pieces = Number(value) ; break;
      case 'weight': returnDetails.weight = Number(value) ; break;
      default: break;
    }

    if (propertyName !== 'arrivalTime') {
      this.setState({ driverInfo, returnDetails, returnCharges, paymentInfoSelect });
    }
  }

  deleteItemOfDriverInQueue = async (driverId: number): Promise<void> => {

    try {
      const resp: ApiResponse<Array<DriverQueue>> = await queueRemote.deleteDriverOfQueue(driverId)
    }
    catch (error) {

      return this.props.receiveError(error);
    }
  }

  handleSubmit = async (): Promise<void> => {

    if(this.state.navigate) {
      this.props.history.push('/manage-imports');
    } else {
      const isValid: boolean = this.isValid();
      const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
      let paymentOther = this.state.paymentInfoSelect === 'other' ?  this.state.returnCharges : this.state.paymentInfoSelect;
      if (!isValid) {
  
        let apiResponseOrder: ApiResponse<PickupOrderGha>;
        this.setState({ showText: true, navigate: true });
        setTimeout(() => {
          this.setState({ showText: false });
        }, 3000);
        try {
          apiResponseOrder = await cartRemote.returnPay(true, driverInfo, this.state.returnDetails, this.props.awb, paymentOther);
  
          if (apiResponseOrder.result) {
           
          }
  
          if (apiResponseOrder.error) {
            this.props.receiveError(apiResponseOrder.error);
          }
        } catch (error) {
          return this.props.receiveError(error);
        }
      }
    }
  }

  changeArrivalTime = (value: string): void => {

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    const valueInPureFormat: string = value.replace(':', '');

    if (!Number.isInteger(Number(valueInPureFormat)) && valueInPureFormat) {
      return;
    }

    driverInfo.arrivalTime = value.length > 5 ? value.substring(0, 5) : value;
    this.setState({ driverInfo }, () => {});
  }

  getAltPaymentOptions = (): void => {

    paymentsRemote.getPaymentOptions().then((resp: ApiResponse<AlternativePaymentOptions>) => {

      const paymentOptions: AlternativePaymentOptions | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      
      if (paymentOptions) {
        this.setState({ paymentOptions })
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  isValid = (): boolean => {

    const errors: any = { ...this.state.errors };
    const driverInfo: DriverInfoModel = { ... this.state.driverInfo };
    const returnErrors: any = { ...this.state.returnErrors };
    const returnDetails = { ... this.state.returnDetails };
    let hasError: boolean = false;
    Object.entries(driverInfo).forEach(([key, value]) => {

      if (value === '' && key !== 'driverIdType' && key !== 'truckPlateNumber' && key !== 'rfsNumber' && key !== 'interlineTransfer') {
       errors[key] = 'Add';
        hasError = true;
      }

      if (key === 'arrivalTime') {
      
        var timeSplit: Array<string> = value.split(':');

        const valid: boolean = /^\d\d:\d\d$/.test(value) && Number(timeSplit[0]) >= 0 && Number(timeSplit[0]) <= 23 && Number(timeSplit[1]) >= 0 && Number(timeSplit[1]) < 60;

        if (valid) {
          return;
        }

        errors[key] = 'Invalid';
        hasError = true;
      }
    });

    Object.entries(returnDetails).forEach(([key, value]) => {

      if (value === '' || value === 0 || value === null) {
        returnErrors[key] = 'Add';
        hasError = true;
      }
      if((key === 'pieces' && value != null && value > this.props.awb.pieces) || (key === 'weight' && value != null && value > this.props.awb.weight)) {
        returnErrors[key] = 'Invalid';
        hasError = true;
      }
    });
    if(this.state.returnCharges === '' && this.state.paymentInfoSelect === '') {
      hasError = true;
    }

    this.setState({ errors, returnErrors });
    return hasError;
  }

  handleClick = (event: any) => {

    const errors: any = { ...this.state.errors }
    const key: string = event.target.id;
    if(key === 'driverId') {
      const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
      driverInfo.maskedDriverId = driverInfo.driverId;
      this.setState({ driverInfo });
    } else {
      errors[key] = '';
      this.setState({ errors });
    }
  }

  addToCart = () => {

    cartRemote.addAirwayBillToReturnCart(this.props.awb.code, this.props.awb.number, this.props.awb.version).then((resp: ApiResponse<Cart>) => {

      const cart: Cart | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      const cartItemsLength: number = (cart && cart.cart) ? cart.cart.length : 0;

      if (cart) {
        this.props.updateCart(cart);
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  maskon = () => {

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    driverInfo.maskedDriverId =  driverInfo.driverId.replace(/.(?=.{4,}$)/g, '#');
    this.setState ({ driverInfo });
  }
   
  render () {
    return (
      <AwbReturnModal 
        modalOpen={ this.props.modalOpen }
        handleCloseModal={ this.closeModal }
        driverInfo={ this.state.driverInfo }
        selectedDock={ this.state.selectedDock }
        docks={ this.state.ghaDocks }
        handleChange={ this.handleChange }
        handleSubmit={ this.handleSubmit }
        errors={ this.state.errors }
        onClick={ this.handleClick }
        delivererType={ this.state.delivererType }
        maskon={ this.maskon }
        handleOpenModal={ this.props.handleOpenModal }
        returnDetails={ this.state.returnDetails }
        returnCharges={ this.state.returnCharges }
        returnErrors={ this.state.returnErrors }
        cartItem={ findCartItemByCodeAndNumber(this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.cart) }
        paymentInfoSelect={ this.state.paymentInfoSelect }
        paymentOptions={ this.state.paymentOptions }
        paymentType={ this.state.paymentType }
        showText={ this.state.showText }
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    manualEntryEdit: state.manualEntryEdit,
    manualEntryAdd: state.manualEntryAdd,
    gha: state.ghaInfo,
    cart: state.cart
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId)),
    updateCart: (cart: Cart) => dispatch(updateWholeCart(cart)),
    deleteAwbFromCart: (awbCode: string, awbNumber: string) => dispatch(deleteAwbFromCart(awbCode, awbNumber)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManualEntryModalContainer);
